import { message, notification } from "antd";
import { getStateFromGST } from "./getLocality";
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const buyerDetails = async (gstNumber, name) => {
  console.log("gst from buyer", gstNumber);
  if (!gstNumber) {
    notification.error({ message: "Please send gst number calling from buyer details" });
    return;
  }
  const params = new URLSearchParams({ gstNumber });
  if (name != null && String(name).trim() !== "") {
    params.set("name", String(name).trim());
  }
  const response = await fetch(
    `${apiBaseUrl}/inventoryManagement/getInformationFromGST?${params.toString()}`,
    {
      method: "GET",
    }
  );
  const data = await response.json();
  if (data.success) {
    console.log("data from gst", data);
  } else {
    notification.error({ message: message });
  }
  // const Locality = await getStateFromGST(gstNumber);
  const result = data.result;
  return {
    Gstin: result.gstNumber,
    LglNm: result.name,
    TrdNm: null,
    Addr1: result.add1 ? result.add1 : "",
    Addr2: result.add2 ? result.add2 : "",
    Ph: result?.contactNumber,
    // Em: result?.email,
    STcd: result.gstNumber.slice(0, 2),
    Pos: result.gstNumber.slice(0, 2),
    Loc: result?.city,
    Pin: result?.pinCode 
  };
};

export default buyerDetails;

// BuyerDtls: {
//     Gstin: "23AALCP1452B1ZW",
//     LglNm: "PUSHP BRAND INDIA PRIVATE LIMITED",
//     TrdNm: null,
//     Pos: "23",
//     Addr1: "19, Mahavar Nagar , Annapurna Road,",
//     Addr2: "Indore, Madhya Pradesh, 452009",
//     Loc: "Indore",
//     Pin: 452009,
//     Stcd: "23",
//     Ph: "9425065526",
//     Em: "marketing@pushpmasale.com",
//   },
